import { Component } from '@angular/core';
import { DocumentLibraryConstants } from '../document/document-library-constants';
import { MyDocFormattingConstants } from './constants/my-doc-formatting-constants';
import { MyDocFormattingService } from './services/my-doc-formatting.service';
import { LabelConstants } from '../shared/constants/label-constants';

@Component({
  selector: 'app-my-doc-formattings',
  templateUrl: './my-doc-formattings.component.html',
  styleUrls: ['./my-doc-formattings.component.scss']
})
export class MyDocFormattingsComponent {
  topBarTitle:string = MyDocFormattingConstants.MyDocFormatting_TopBarTitle;
  showAllLabel:string=MyDocFormattingConstants.MyDocFormatting_ShowAllLabel;
  isIncludeAll = MyDocFormattingConstants.MyDocFormatting_IsIncludeAll;
  showInformationIconCheckbox = MyDocFormattingConstants.MyDocFormatting_ShowInformationIconCheckbox;
  inactiveTooltip:string = MyDocFormattingConstants.MyDocFormatting_CheckBoxHoverToolTip;
  documentSearchResult:any[] = [];
  panelListType:string = DocumentLibraryConstants.DocFormattings_PanelListType;
  showLoader : boolean = true;
  isScreenAccessible : boolean = true;
  errorMessage !: string;

  constructor(private myDocFormattingService : MyDocFormattingService){ 
  }

  ngOnInit(): void {
    this.getPanelListData(this.isIncludeAll);
  }
  
    includeInactive(isIncludeAll: boolean) {
        this.showLoader = true;
    this.getPanelListData(isIncludeAll);
  }
  
  getPanelListData(isIncludeAll:boolean){
      this.myDocFormattingService.getMyDocFormattings(isIncludeAll).subscribe({
          error: (err) => {
              if (err.status === LabelConstants.Forbidden_StatusCode) {
                  this.errorMessage = err.error.detail;
              }
              this.isScreenAccessible = false
          },
          next: (serviceData) => {
              this.documentSearchResult = serviceData;
              this.showLoader = false;
          }
    });
  }
}
